import { observable, action, runInAction, configure, makeObservable } from 'mobx';
import { AuthenticationMethod } from '../models/digitalidentity';
import ResetMultifactorAuthenticationResponse from '../models/mfa-types';
import { getDigitalIdentity } from '../services/get-digital-identity';
import { resetMfaService } from '../services/reset-mfa-service';

// Enable Restrict mode. Recommended
configure({ enforceActions: 'observed' });

export default class MfaStore {

  readonly RESET_ERROR = 'Failed to reset MFA';
  readonly FETCH_ERROR = 'Failed to fetch MFA details';

  constructor() {
    makeObservable(this);
  }

  @observable mfaDetails: AuthenticationMethod | null = null;
  @observable loading = false;
  @observable error: string | null = null;
  @observable disableResetButton = true;

  @observable resetStatus: ResetMultifactorAuthenticationResponse | null = null;
  @observable resetLoading = false;
  @observable resetError: string | null = null;

  @action
  async fetchMfaDetails() {
    this.loading = true;
    this.error = null;

    try {
      // Call the API to fetch MFA details
      const response = await getDigitalIdentity.getIdentity();
      runInAction(() => {
        // if multifactorAuthenticationMethods is empty array then response is undefined
        // so disable reset button on error or if mfa method is empty
        if (response) {
          this.mfaDetails = response;
          this.disableResetButton = false;
        } 
        this.loading = false; 
      });
    } catch (error: any) {
      runInAction(() => {
        this.error = error.message || this.FETCH_ERROR;
        this.loading = false;
      });
    }
  }

  @action
  async resetMfa() {
    this.resetLoading = true;
    this.resetError = null;

    try {
      // Call the API to reset MFA
      const status = await resetMfaService.resetMfa();
      runInAction(() => {
        status.success ? this.resetStatus = status : this.resetError = this.RESET_ERROR;
        this.resetLoading = false;
      });
    } catch (error: any) {
      runInAction(() => {
        this.resetError = error.message || this.RESET_ERROR;
        this.resetLoading = false;
      });
    }
  }

  @action
  clearResetError() {
    this.resetError = null;
  }

  @action
  resetStore() {
    this.mfaDetails = null;
    this.loading = false;
    this.error = null;
    this.resetStatus = null;
    this.resetLoading = false;
    this.resetError = null;
  }
}

export const mfaStore = new MfaStore();
